import React, { useRef } from 'react';
import OptionsAndOther from '../../../../questionnaire/choose_an_option';
import VonjoIsi from '../../../../vonjo/important_safety_information';
import ImportantSafetyInformationStickyFooter from '../../../../isi_sticky_footer';

export default function MfPrescribedMedication({ value, onSubmit, onBack }) {
  const isiRef = useRef(null);

  return (
    <div>
      <OptionsAndOther
        answers={{ mfPrescribedMedication: value }}
        keyForAnswer={'mfPrescribedMedication'}
        onSubmit={onSubmit}
        onBack={onBack}
        choices={['Yes', 'No']}
        title={`Are you or the patient currently prescribed or currently taking VONJO® (pacritinib)?`}
        para={``}
        showOther={false}
        ctaTxt='Next'
        selectOne
      />

      <div ref={isiRef}>
        <ImportantSafetyInformationStickyFooter component={<VonjoIsi />} ref={isiRef} />
      </div>
    </div>
  );
}
